<div *ngIf="!wizard" >
    <div >
      <div class="modal-header">
        <h6 class="h6 header-h6">{{ 'orgprojectedit.header' | trans }}</h6>
        <button (click)="closeModal()" type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <form  name="projectcreate">

            <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">{{ 'orgprojectedit.projecttitle' | trans }}</h6>
            <input class="form-control" type="text" name="title" placeholder="{{ 'orgprojectedit.projecttitleplace' | trans }}" [(ngModel)]="project.title" required>
            <!--h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">Subtitle</h6>
            <input class="form-control" type="text" name="subtitle" placeholder="Project Subtitle..." [(ngModel)]="project.subtitle">
            <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">Short description</h6>
            <textarea class="form-control sm-descript" type="text" placeholder="Project Short Description..." name="shortdescription"  [(ngModel)]="project.shortdescription"></textarea-->
            <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">{{ 'orgprojectedit.description' | trans }}</h6>
            <textarea class="form-control lg-descript" type="text" placeholder="{{ 'orgprojectedit.descriptionplace' | trans }}" name="projectdescription"  [(ngModel)]="project.projectdescription" required></textarea>
            
            <!----h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">Scope</h6>
            <input class="form-control" type="text" name="scope"  [(ngModel)]="project.scope"---->

            <!---<h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">Location</h6>
            <select id="inputState" name="projectlocation" placeholder="Choose..." [(ngModel)]="project.projectlocation" class="form-control select">
              <option selected>Choose...</option>
              <option>Herning</option>
              <option>Copenhagen</option>
              <option>Aarhus</option>
            </select>--->
            <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">{{ 'orgprojectedit.startdate' | trans }}</h6>
            <input 
            type="date" 
            class="form-control stageinput" 
            name="startdate" 
            [ngModel]="project.start_date | date:'yyyy-MM-dd'" 
            (ngModelChange)="project.start_date = $event" 
            required>
            <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">{{ 'orgprojectedit.enddate' | trans }}</h6>
            <input type="date" class="form-control stageinput" name="enddate" 
            [ngModel]="project.end_date | date:'yyyy-MM-dd'" 
            (ngModelChange)="project.end_date = $event" required>
            
            <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">Workload FTE</h6>
            <input type="number" min="0" step="0.1" class="form-control" name="workload_fte" placeholder="1.0" [(ngModel)]="project.workload_fte">
            
            <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">{{ 'orgprojectedit.customer' | trans }}</h6>
            <input disabled  id="customerchoise" name="customer" [(ngModel)]="project.customername" class="form-control">
            <!-- <select disabled (change)="setCustomer(project.customer)" id="customerchoise" name="customer" [(ngModel)]="project.customer" class="form-control" required>
              <option selected>Choose...</option>
              <option *ngFor="let customer of customerList; let i = index" value="{{customer.customerId.split('_')[0]}}" >{{customer.title}}</option>
            </select> -->
            <div  *ngIf="dealList && dealList.length > 0" class="form-group">
              <p class="mb-0 cursor-pointer">{{ 'orgprojectedit.deal' | trans }}</p>
              <select  id="addcustomerdealchoise" name="deal" [(ngModel)]="project.dealId" class="form-control" required>
                <option>{{ 'orgprojectedit.dealplace' | trans }}</option>
                <option *ngFor="let deal of dealList" value="{{deal.dealId.split('_')[0]}}" >{{deal.dealname}}</option>
              </select>
            </div>
          </form>
          <div *ngIf="errorMessage?.length > 0" class="alert alert-danger ml-0 mr-0">
            <h6 class="error-msg mb-0">{{ errorMessage | trans }}</h6>
        </div>
          <div class="row">
            <div class="col">
              <button (click)="closeModal()" data-dismiss="modal" class="btn-close"><h6 class="btn-save-text">{{ 'orgprojectedit.close' | trans }}</h6></button>
            </div>
            <div class="col">
              <button  (click)="updateProject()"  class="btn-save float-right" type="submit"><h6 class="btn-save-text">{{ 'orgprojectedit.update' | trans }}</h6></button>
            </div>

          </div>
                 <!-- INTEREST FUNCTION COMMENTED OUT <app-orgprojectinterestadd (interestAddtolist)="addInterest($event)" [projectId]="project.projectId" ></app-orgprojectinterestadd>
                  <app-orgprojectinterestlist [projectintersttoadd]="projectintersttoadd" [project]="project" ></app-orgprojectinterestlist>
            -->
 
    </div>
  </div>
 </div>
 <div *ngIf="wizard" class="modal-body p-0">
  <form  name="projectcreate">

      <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">{{ 'orgprojectedit.projecttitle' | trans }}</h6>
      <input class="form-control" type="text" name="title" placeholder="{{ 'orgprojectedit.projecttitleplace' | trans }}" [(ngModel)]="project.title" required>
      <!--h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">Subtitle</h6>
      <input class="form-control" type="text" name="subtitle" placeholder="Project Subtitle..." [(ngModel)]="project.subtitle">
      <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">Short description</h6>
      <textarea class="form-control sm-descript" type="text" placeholder="Project Short Description..." name="shortdescription"  [(ngModel)]="project.shortdescription"></textarea-->
      <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">{{ 'orgprojectedit.description' | trans }}</h6>
      <textarea class="form-control lg-descript" type="text" placeholder="{{ 'orgprojectedit.descriptionplace' | trans }}" name="projectdescription"  [(ngModel)]="project.projectdescription" required></textarea>
      
      <!----h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">Scope</h6>
      <input class="form-control" type="text" name="scope"  [(ngModel)]="project.scope"---->

      <!---<h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">Location</h6>
      <select id="inputState" name="projectlocation" placeholder="Choose..." [(ngModel)]="project.projectlocation" class="form-control select">
        <option selected>Choose...</option>
        <option>Herning</option>
        <option>Copenhagen</option>
        <option>Aarhus</option>
      </select>--->
      <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">{{ 'orgprojectedit.startdate' | trans }}</h6>
      <input type="date" class="form-control stageinput" name="startdate" [ngModel]="project.start_date | date:'yyyy-MM-dd'" 
      (ngModelChange)="project.start_date = $event" required>
      <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">{{ 'orgprojectedit.enddate' | trans }}</h6>
      <input type="date" class="form-control stageinput" name="enddate" [ngModel]="project.end_date | date:'yyyy-MM-dd'" 
      (ngModelChange)="project.end_date = $event"required>
      
      <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">Workload FTE</h6>
      <input type="number" min="0" step="0.1" class="form-control" name="workload_fte" placeholder="1.0" [(ngModel)]="project.workload_fte">
      
      <h6 class="h6 h6_custom_sm cursor-pointer header-custom projectheader">{{ 'orgprojectedit.customer' | trans }}</h6>
      <input disabled  id="customerchoise" name="customer" [(ngModel)]="project.customername" class="form-control">
      <!-- <select disabled (change)="setCustomer(project.customer)" id="customerchoise" name="customer" placeholder="Choose..." [(ngModel)]="project.customer" class="form-control mb-0" required>
        <option selected>Choose...</option>
        <option  *ngFor="let customer of customerList; let i = index" value="{{customer.customerId.split('_')[0]}}" >{{customer.title}}</option>
      </select> -->
      <small id="emailHelp" class="form-text text-muted mb-3">{{ 'orgprojectedit.customerhelp' | trans }}</small>
      <div  *ngIf="dealList && dealList.length > 0" class="form-group">
        <p class="mb-0 cursor-pointer">{{ 'orgprojectedit.deal' | trans }}</p>
        <select  id="addcustomerdealchoise" name="deal" [(ngModel)]="project.dealId" class="form-control" required>
          <option selected>{{ 'orgprojectedit.dealplace' | trans }}</option>
          <option  *ngFor="let deal of dealList; let i = index" value="{{deal.dealId.split('_')[0]}}" >{{deal.dealname}}</option>
        </select>
      </div>
    </form>
    <div *ngIf="updateMessage" class="alert alert-success" role="alert">
    <h6 class="error-msg mb-0">{{ updateMessage }}</h6>
    </div>
  <div *ngIf="errorMessage && !updateMessage" class="alert alert-danger ml-0 mr-0">
    <h6 class="error-msg mb-0">{{ errorMessage | trans }}</h6>
</div>
    <div class="row">
      <div class="col">
        <button data-dismiss="modal" class="btn-close"><h6 class="btn-save-text">{{ 'orgprojectedit.close' | trans }}</h6></button>
      </div>
      <div class="col">
        <button (click)="updateProject()" class="btn-save float-right" type="submit"><h6 class="btn-save-text">{{ 'orgprojectedit.update' | trans }}</h6></button>
      </div>

    </div>
           <!-- INTEREST FUNCTION COMMENTED OUT <app-orgprojectinterestadd (interestAddtolist)="addInterest($event)" [projectId]="project.projectId" ></app-orgprojectinterestadd>
            <app-orgprojectinterestlist [projectintersttoadd]="projectintersttoadd" [project]="project" ></app-orgprojectinterestlist>
      -->

</div>
